export default [{
    path: 'employments/add-invited/:booking_id/:campaign_id',
    name: 'employer-invite-applicantwww',
    component: () => import ('source/pages/applicants/EmployerInviteApplicants.vue'),
    props: true,
    meta: {
        title: 'HQZen',
        canDisplayGlobalModals: false
    },
    children: [{
        path: ':applicant_id',
        name: 'applicant-info-modal-invite-more-applicants',
        component: () => import ('source/components/bookings/CardApplicantInfoModal.vue'),
        props: true,
        meta: {
            title: 'HQZen',
            canDisplayGlobalModals: false
        }
    }]
}];
